/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';

// MaterialReactTable
import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";

//import translation function for language translation
import { useTranslation } from 'react-i18next';
//import context
import { GlobalProvider } from "context/GlobalContext";
/* importing groups data  */
import groupsData from '../../data/GroupsData.json';

const GroupsBody = ({ downloadExcel, search }) => {
  const {
    screenHeight,
  } = useContext(GlobalProvider);

  const { t } = useTranslation(); //for translation

  const [rowSelection, setRowSelection] = useState({});

  /* Excel export */
  const exportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(groupsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Group.xlsx");
  };

  // Column definitions
  const tableColumns = useMemo(() => [
    {
      id: "name",
      accessorKey: "name",
      header: t("Name"),
      size: 200,
    },
    {
      id: "events",
      accessorKey: "events",
      header: t("Events"),
      size: 200,
    },
  ], []);

  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  return (
    <div className="table-responsive">
      <MaterialReactTable
        columns={tableColumns}
        data={groupsData}
        enableSorting
        enableFilters
        enableGlobalFilter={false}
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        getRowId={(row) => row._id}
        state={{ rowSelection }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
        initialState={{
          pagination: { pageSize: 100, pageIndex: 0 },
          showColumnFilters: true,
        }}
      />
    </div>
  );
};

export default GroupsBody;
